import { CommonModule } from "@angular/common";
import { Component, inject, input } from "@angular/core";
import { RouterLink } from "@angular/router";
import { EvCore } from "ev-core";
import { IMiniInfocardCommercial } from "src/models/commercial/IMiniInfocardDataCommercial.model";

@Component({
    selector: "commercial-sale-property-info",
    templateUrl: "./commercial-sale-property-info.component.html",
    styleUrl: "./commercial-sale-property-info.component.scss",
    imports: [EvCore, CommonModule, RouterLink],
})
export class CommercialSalePropertyInfoComponent {
    selectedSale = input.required<IMiniInfocardCommercial>();
}
